import { createQueryHook } from "../factory";

const revCodeKeys = {
  all: ["revCodes"] as const,
  lists: () => [...revCodeKeys.all, "list"] as const,
  list: <T>(filters: T) => [...revCodeKeys.lists(), filters] as const,
};

export const revCodes = {
  getUniqueRevCodes: createQueryHook({
    methodSelector: (alaffiaClient) => alaffiaClient.revCodes.getUniqueRevCodes,
    queryKeyFn: revCodeKeys.list,
  }),
};
